/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmDocumentQueryRegion extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AwsSsmDocumentQueryRegion");
    }

    getFixupPrototypeFunction() { return AwsSsmDocumentQueryRegion.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmDocumentQueryRegion>): AwsSsmDocumentQueryRegion {
        let obj = Object.assign(new AwsSsmDocumentQueryRegion(), model);
        AwsSsmDocumentQueryRegion.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmDocumentQueryRegion>): AwsSsmDocumentQueryRegion {
        if (!model) return null;
        return AwsSsmDocumentQueryRegion.newInstance(<AwsSsmDocumentQueryRegion> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmDocumentQueryRegion) {
        if (!obj) return;

        models.AwsSsmDocumentQueryRegion.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmDocumentQueryRegion): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AwsSsmDocumentQueryRegion.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Regions for the document
     */
    regions: Array<string>;

}
